import React, { useState } from "react";
import { Container, Paper, Grid, Box, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Notification from "../../../../../components/mui/Notification";
import { TourRide, TourStep } from "../../../../../components";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import { TitleIntro } from "./TitleIntro";
import { DecisionPoint } from "./DecisionPoint";
import { Options } from "./Options";
import { Question } from "./Question";
import ResponsiveDialog from "../../../../../components/ResponsiveDialog";
import * as caseStudyService from "../../../services/CasestudyService";
import { SituationBackground } from "./SituationBackground";
import { CASE_STUDY_TYPE_MINI } from "../../../helper/Constants";

const Review = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const casestudy = state.casestudy;
  const course = state.course;
  const caseStudyId = state.casestudy?.id;
  const [updating, setUpdating] = useState();
  const [submitting, setSubmitting] = useState();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [finalDialog, setFinalDialog] = useState({
    isOpen: false,
  });

  const reviewTourSteps = [
    {
      target: "#bcl-assistant",
      content: (
        <TourStep
          title={"Use AI Assistant to Add Content Block"}
          description={
            "Need help building your case study? Click the AI Assistant button to generate and add relevant content blocks."
          }
        />
      ),
    },
  ];

  const submit = () => {
    setSubmitting(true);
    caseStudyService
      .submitReview({
        caseStudyId,
        caseStudyType: CASE_STUDY_TYPE_MINI,
        paymentStatus: casestudy.paymentStatus,
        courseId: course.id,
      })
      .then((ignored) => {
        setTimeout(() => {
          // Add your logic for the transition
          navigate(-1, { replace: true });
        }, 1000);
      })
      .catch((e) => {
        console.error(e);
        setNotify({
          isOpen: true,
          message: "Could not submit the case study. Please try again later",
          type: "error",
        });
      })
      .finally(() => setSubmitting(false));
  };

  const handleSubmit = () => {
    setFinalDialog({
      isOpen: true,
      title: "Confirm Final Submission",
      content:
        "This is the final step in creating your case study. Once submitted, the content will be locked and cannot be edited.",
      actions: [
        {
          label: "Cancel",
          onClick: () =>
            setFinalDialog({
              ...finalDialog,
              isOpen: false,
            }),
        },
        {
          label: "Confirm",
          onClick: () => {
            setFinalDialog({
              ...finalDialog,
              isOpen: false,
            });
            submit();
          },
          autoFocus: true,
        },
      ],
    });
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <TourRide
        name="case-study-creation-review-page-new"
        steps={reviewTourSteps}
      />
      <Paper variant="outlined" sx={{ my: { xs: 1 }, p: { xs: 2 } }}>
        <React.Fragment>
          <Grid container spacing={1}>
            <TitleIntro
              caseStudyId={caseStudyId}
              handleUpdatingStatus={(value) => setUpdating(value)}
            />

            {/* <Challenges
              caseStudyId={caseStudyId}
              handleUpdatingStatus={(value) => setUpdating(value)}
            /> */}

            <SituationBackground
              caseStudyId={caseStudyId}
              handleUpdatingStatus={(value) => setUpdating(value)}
            />

            <Options
              caseStudyId={caseStudyId}
              handleUpdatingStatus={(value) => setUpdating(value)}
            />

            <DecisionPoint
              caseStudyId={caseStudyId}
              handleUpdatingStatus={(value) => setUpdating(value)}
            />

            <Question
              caseStudy={casestudy}
              handleUpdatingStatus={(value) => setUpdating(value)}
            />
          </Grid>
        </React.Fragment>
      </Paper>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button disabled={updating || submitting} onClick={handleSubmit}>
          Submit
        </Button>
        <Button
          color="inherit"
          disabled={updating}
          onClick={() => navigate(-1)}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <ResponsiveDialog dialog={finalDialog} setDialog={setFinalDialog} />
    </Container>
  );
};

export default Review;
